import { render, staticRenderFns } from "./TextEditAreaComponent.vue?vue&type=template&id=7fa7a85a&scoped=true&"
import script from "./TextEditAreaComponent.vue?vue&type=script&lang=js&"
export * from "./TextEditAreaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa7a85a",
  null
  
)

export default component.exports